<template>
  <section class="testimonials">
    <div class="max-w-4xl mx-auto px-4 py-12">
      <div>
        <div id="testimonialHeading" class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
          <h2 class="text-5xl italic font-bold text-center sm:text-left">
            Testimonials
          </h2>
          <div id="arrows" class="flex gap-2 justify-center sm:justify-start">
            <div class="border border-white p-4 cursor-pointer w-[120px] sm:w-[60px] h-[60px] flex items-center justify-center hover:bg-white/40 transition-colors duration-200" @click="prevTestimonial"> 
              <span class="text-white">&lt;</span>
            </div>
            <div class="border border-white p-4 cursor-pointer w-[120px] sm:w-[60px] h-[60px] flex items-center justify-center hover:bg-white/40 transition-colors duration-200" @click="nextTestimonial">
              <span class="text-white">&gt;</span>
            </div>
          </div>
        </div>

        <div id="testimonialContent" class="mt-8">
          <transition name="fade" mode="out-in">
            <div :key="currentIndex" class="testimonial-card">
              <div class="quote">
                <img
                  src="@/assets/images/home/quote.png"
                  alt="Quote symbol"
                  class="w-16 h-16"
                />
                <p class="testimonial-message">
                  {{ testimonials[currentIndex].message }}
                </p>
              </div>
              <p class="testimonial-name text-2xl">
                {{ testimonials[currentIndex].name }}
              </p>
              <p class="testimonial-designation">
                {{ testimonials[currentIndex].designation }}
              </p>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </section>
</template>
    
<script>
  import testimonials from '@/data/testimonials.json';

  export default {
    name: 'HomeTestimonials',
    data() {
      return {
        testimonials,
        currentIndex: 0,
        autoplayInterval: null
      };
    },
    methods: {
      nextTestimonial() {
        this.currentIndex = (this.currentIndex + 1) % this.testimonials.length;
      },
      prevTestimonial() {
        this.currentIndex = this.currentIndex === 0 
          ? this.testimonials.length - 1 
          : this.currentIndex - 1;
      },
      startAutoplay() {
        this.autoplayInterval = setInterval(this.nextTestimonial, 6000);
      },
      stopAutoplay() {
        if (this.autoplayInterval) {
          clearInterval(this.autoplayInterval);
        }
      }
    },
    mounted() {
      this.startAutoplay();
    },
    beforeUnmount() {
      this.stopAutoplay();
    }
  };
</script>
  
<style scoped>
  .testimonials {
    background-color: black;
    background-image: url('../../assets/images/home/testimonials-bg.png');
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: cover;
    width: auto;
    min-height: 440px;
  }

  h2, .testimonial-message, .testimonial-name {
    color: var(--empire-white-text);
  }

  h2 {
    font-family: "Roboto Condensed", sans-serif;
    font-weight: 700;
  }

  .testimonial-card {}

  .quote {
    margin-bottom: 10px;
  }

  .testimonial-message {
    font-size: 24px;
    position: relative;
    margin-bottom: 15px;
    line-height: 36px;
    font-style: italic;
    font-weight: 300;
  }

  .testimonial-name {
    font-family: "Roboto Condensed", sans-serif;
    font-style: italic;
    font-weight: 700;
  }

  .testimonial-designation {
    font-size: 0.9rem;
    color: white;
  }

  /* Transition animations */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
</style>